import React from "react";
import { ANNOUNCEMENTS } from "../mock/mock";
import { Sparkles } from "lucide-react";
import { useContent } from "../context/ContentContext";

const AnnouncementBar = () => {
  const { content } = useContent();
  const items = (content.announcements || ANNOUNCEMENTS.map((t, i) => ({ id: `f${i}`, text: t, active: true })))
    .filter((a) => a.active !== false)
    .map((a) => a.text || a);
  if (items.length === 0) return null;
  const list = [...items, ...items];
  return (
    <div className="bg-brand text-white overflow-hidden">
      <div className="relative whitespace-nowrap">
        <div className="ardf-marquee inline-flex items-center gap-10 py-2 text-[12.5px] font-medium tracking-wide">
          {list.map((t, i) => (
            <span key={i} className="inline-flex items-center gap-2">
              <Sparkles className="h-3.5 w-3.5 text-gold" />
              <span>{t}</span>
              <span className="text-gold">✦</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
